<template>
    <canvas width="300" height="240"></canvas>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: ['loading','result'],

    mounted() {
        this.$nextTick(this.draw)
    },

    watch: {
        loading(value) {
            if (value) {
                this.$nextTick(this.draw)
            }
        }
    },

    computed: {
        pieChartLabels() {
            return this.result.map(row => row.name)
        },

        pieChartValues() {
            return this.result.map(row => row.value)
        },

        pieChartColors() {
            return this.result.map(row => row.color)
        },

        totalValue() {
            return this.result.reduce((total, row) => total + row.value, 0)
        }
    },

    methods: {
        draw() {
            new Chart(this.$el.getContext('2d'), {
                type: 'pie',
                data: {
                    datasets: [{
                        data: this.pieChartValues,
                        backgroundColor: this.pieChartColors
                    }],

                    labels: this.pieChartLabels
                },
                options: {
                    tooltips: {
                        callbacks: {
                            label: (t, d) => {
                                let value = d.datasets[t.datasetIndex].data[t.index]

                                return d.labels[t.index] + ': ' + this.$options.filters.price(value) + ' (' + Math.round(value / this.totalValue * 100) + ' %)'
                            }
                        }
                    },

                    plugins: {
                        datalabels: {
                            display: false
                        }
                    },

                    legend: {
                        display: false
                    }
                }
            })
        }
    }
}
</script>
